import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import TextField from '../../../../../components/FormLegacy/FormFieldsV2/TextField'
import Icon from '../../../../../components/Icons'
import {
  updateTaskAssignDays,
  updateTaskDueDateDays,
  updateChecklistTemplate,
} from '../../../../../reducers/Organisation/checklistsReducer'
import { useSnackbar } from '../../../../../helpers/hooks/useSnackbar'

const MIN_ASSIGN_DAYS = 0
const MIN_DUE_DATE_DAYS = 1
const MAX_DAYS = 99

const EditableDaysCell = ({
  data: { id, condition, trigger, days, name, defaultTrigger = false },
  updateTaskAssignDays = () => {},
  updateChecklistTemplate = () => {},
  updateTaskDueDateDays = () => {},
  fullTemplate = {},
}) => {
  const { t } = useTranslation(['checklists-legacy'])
  const [isEditMode, setIsEditMode] = useState(false)
  const [value, setValue] = useState(days || defaultTrigger ? 30 : null)
  const { displaySnackbar } = useSnackbar()

  useEffect(() => {
    days !== value && setValue(days)
  }, [days])

  const handleValueChange = (e) => {
    let value = parseInt(e.target.value)
    if (value > MAX_DAYS) return
    setValue(value)
  }

  const handleBlur = () => {
    try {
      if (name === 'assignTask') {
        updateTaskAssignDays(id, value || MIN_ASSIGN_DAYS)
      } else if (name === 'dueDate') {
        updateTaskDueDateDays(id, value || MIN_DUE_DATE_DAYS)
      } else {
        updateChecklistTemplate({
          checklistId: id,
          sendData: { ...fullTemplate, assignTaskDays: value },
          tempCategory: fullTemplate.isTemplate ? 'templates' : 'custom',
          handleError: displaySnackbar,
          handleSuccess: () => displaySnackbar(t('checklists-legacy:snackbars.checklistUpdated')),
        })
      }
    } catch ({ message }) {
      console.error(message)
    } finally {
      setIsEditMode(false)
    }
  }

  const handleEditClick = (e) => {
    e.stopPropagation()
    setIsEditMode(true)
  }

  const renderTooltip = () => (
    <React.Fragment>
      <div
        data-tip={t('checklists-legacy:editableDaysCell.tooltip')}
        data-for="editable-days-cell-tip"
      >
        <Icon icon="info" className="info" viewBox="0 0 25 25" />
      </div>
      <ReactTooltip
        className="editable-days-cell__tooltip"
        id="editable-days-cell-tip"
        effect="solid"
        place="top"
      />
    </React.Fragment>
  )

  if ((!trigger || !condition) && !defaultTrigger) return '–'

  return (
    <div className="editable-days-cell">
      {isEditMode ? (
        <TextField
          autoFocus
          type="number"
          value={value}
          onChange={handleValueChange}
          onBlur={handleBlur}
          min={name === 'assignTask' ? MIN_ASSIGN_DAYS : MIN_DUE_DATE_DAYS}
        />
      ) : (
        days
      )}{' '}
      {defaultTrigger
        ? t('checklists-legacy:editableDaysCell.daysConditionTrigger', {
            condition: condition || 'before',
            trigger,
          })
        : t('checklists-legacy:editableDaysCell.daysConditionTrigger', {
            condition,
            trigger: trigger.replace('-', ' '),
          })}
      {isEditMode ? (
        renderTooltip()
      ) : (
        <button onClick={handleEditClick}>
          <Icon icon="pencil" />
        </button>
      )}
    </div>
  )
}

EditableDaysCell.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    condition: PropTypes.string,
    trigger: PropTypes.string,
    days: PropTypes.number,
  }),
  fullTemplate: PropTypes.object,
  updateTaskAssignDays: PropTypes.func,
  updateTaskDueDateDays: PropTypes.func,
  updateChecklistTemplate: PropTypes.func,
}

export default connect(null, {
  updateTaskAssignDays,
  updateTaskDueDateDays,
  updateChecklistTemplate,
})(EditableDaysCell)
